import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';

export const UploadLogoIconButton = styled(IconButton, { label: 'IconButton' })(({ theme }) => ({
  width: theme.spacing(14),
  height: theme.spacing(14),
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: theme.palette.grey[200],
  '&:hover': {
    backgroundColor: theme.palette.grey[300],
  },
}));

export const PlusIconWrapper = styled(Box, { label: 'PlusIconWrapper' })(({ theme }) => ({
  width: 24,
  height: 24,
  backgroundColor: '#212121',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  borderRadius: '50%',
  transform: 'translate(-50%, -50%)',
  bottom: theme.spacing(-1),
  left: theme.spacing(2),

  '& svg': {
    fill: theme.palette.common.white,
    width: 16,
    height: 16,
  },
}));

export const InputWrapper = styled(Box, { label: 'InputWrapper' })(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 1,
}));

export const StyledImage = styled('img')(({ theme }) => ({
  width: theme.spacing(14),
  height: theme.spacing(14),
  objectFit: 'cover',
  borderRadius: '50%',
  cursor: 'pointer',
}));
